import { AUTH_SUCCESS, AUTH_LOGOUT, AUTH_ERROR, AUTH_ERROR_MESSAGE_REMOVE, SIGN_UP_ERROR } from "../actions/actionTypes";

const initialState = {
  token: null,
  authError: false,
  signUpError: false,
}

const authReducer = (state = initialState, { type, token }) => {
  switch (type) {
    case AUTH_SUCCESS:
      return { ...state, token }
    case AUTH_ERROR:
      return { ...state, authError: true }
    case SIGN_UP_ERROR:
      return {...state, signUpError: true}
    case AUTH_ERROR_MESSAGE_REMOVE:
      return { ...state, authError: false, signUpError: false }
    case AUTH_LOGOUT:
      return { ...state, token: null }
    default:
      return state
  }
}

export default authReducer